.datepicker {
  border-radius: var(--border-radius);
  overflow: hidden;
}
